
import React from 'react';
import { Trade } from '../../types';
import Badge from '../common/Badge';

const formatTradeDate = (dateStr: string) => {
  if (!dateStr) return 'Pending...';
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  return d.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

interface TradeCardProps {
  trade: Trade;
}

// Fix: Add generic type TradeCardProps to React.FC to define expected props correctly
const TradeCard: React.FC<TradeCardProps> = ({ trade }) => {
  const isWin = trade.result === 'WIN';
  
  return (
    <div className="flex items-center justify-between p-5 bg-slate-900/40 border border-slate-800 rounded-2xl hover:border-slate-700 transition-all">
      <div className="flex items-center space-x-4">
        <div className={`w-12 h-12 rounded-xl flex items-center justify-center font-black ${isWin ? 'bg-green-500/10 text-green-500' : 'bg-red-500/10 text-red-500'}`}>
          {trade.asset?.[0] || 'T'}
        </div>
        <div>
          <h4 className="text-white font-bold text-sm">{trade.asset} / USDT</h4>
          <p className="text-slate-500 text-[10px] font-bold uppercase mt-1">{formatTradeDate(trade.tdDate)}</p>
        </div>
      </div>
      
      <div className="hidden sm:block text-center">
        <p className="text-slate-400 text-[10px] font-black uppercase tracking-widest">Investment</p>
        <p className="text-white font-bold text-sm mt-1">${Number(trade.investment || 0).toFixed(2)}</p>
      </div>

      <div className="text-right">
        <Badge label={trade.result} variant={isWin ? 'success' : trade.result === 'PENDING' ? 'warning' : 'error'} />
        <p className={`text-sm font-black mt-1 ${isWin ? 'text-green-500' : 'text-slate-500'}`}>
          {isWin ? `+$${Number(trade.payout || 0).toFixed(2)}` : '-$0.00'}
        </p>
      </div>
    </div>
  );
};

export default TradeCard;
